"use client";
import { useState } from "react";
import Loader from "./loader";
import Navbar from "./navbar";
import TransitionView from "./transition";

export default function PhotoStudioLayout({ children }: { children: React.ReactNode }) {
  const [loadingComplete, setLoadingComplete] = useState(false);

  return (
    <>
      {!loadingComplete && (
        <Loader
          onComplete={() => {
            setLoadingComplete(true);
          }}
        />
      )}

      {loadingComplete && (
        <TransitionView>
          <Navbar>{children}</Navbar>
        </TransitionView>
      )}
    </>
    // <main>{children}</main>
    // <Navbar>{children}</Navbar>
  );
}
